export default __webpack_public_path__ + "static/media/shareTunes2Low.99076391.png";